import { createActionsGroup } from 'utils/redux-utils'

export const orderActions = createActionsGroup('ORDER')
